import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./styles/GlobalStyles";
import { theme } from "./styles/theme";
import Home from "./pages/Home";


const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <div className="page-container">

      <Home />
      </div>
    </ThemeProvider>
  );
};

export default App;
